// Meters as a feet-inches-sixteenths label (`8' 6 1/2"`). Pure — in
// shared-lib so the opening schedule can run on the functions side, which
// cannot load web-app/src/utils/floorPlanUtils.js it came from.

// Helper function to convert meters to feet-inches-fractions
const metersToFeetInches = (meters) => {
  const totalInches = meters * 39.3701; // Convert meters to inches
  let feet = Math.floor(totalInches / 12);
  const remainingInches = totalInches - feet * 12;
  let wholeInches = Math.floor(remainingInches);
  const fraction = remainingInches - wholeInches;

  // Convert decimal fraction to nearest 1/16th
  const sixteenths = Math.round(fraction * 16);

  let fractionStr = '';
  if (sixteenths > 0) {
    // Simplify the fraction
    let numerator = sixteenths;
    let denominator = 16;

    // Reduce fraction
    const gcd = (a, b) => (b === 0 ? a : gcd(b, a % b));
    const divisor = gcd(numerator, denominator);
    numerator /= divisor;
    denominator /= divisor;

    if (numerator === denominator) {
      // If fraction equals 1, add to whole inches
      wholeInches++;
      fractionStr = '';
    } else {
      // Add a bit more space before fractions
      fractionStr = `  ${numerator}/${denominator}`;
    }
  }

  // 11 31/32" and up rounds to twelve inches, which is the next foot
  if (wholeInches === 12) {
    feet++;
    wholeInches = 0;
  }

  // Format the result with proper spacing
  if (feet === 0) {
    if (wholeInches === 0 && fractionStr) {
      return `${fractionStr.trim()} "`;
    }
    return `${wholeInches}${fractionStr} "`;
  } else {
    if (wholeInches === 0 && !fractionStr) {
      return `${feet}'`;
    }
    return `${feet}' ${wholeInches}${fractionStr} "`;
  }
};

module.exports = { metersToFeetInches };
